var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHk = function SvgHk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#abc33e58-b555-4ce8-aa12-820c2147a922a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "04006d2b-fbbe-4fbf-ab35-2b8e85a9db5eb",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#04006d2b-fbbe-4fbf-ab35-2b8e85a9db5eb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DE2910",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.155 7.514C7.443 6.366 8.645 2.83 11.24 3.006c-.526.27-.602.774-.302 1.24.336.524-.03 1.365-.484 1.57-.746.335-.895 1.23-.3 1.698zm.227-.122c.253-2.933 3.99-2.883 4.62-.362-.418-.415-.92-.332-1.272.098-.393.48-1.306.39-1.64.023-.55-.604-1.45-.47-1.708.242zm.092.293c2.88-.615 3.924 2.972 1.697 4.314.276-.523.05-.98-.464-1.19-.574-.236-.756-1.135-.502-1.562.418-.703.026-1.523-.73-1.563zM6.75 10.98c.58.1.945-.257.986-.81.047-.62.845-1.07 1.33-.96.798.18 1.457-.446 1.26-1.178 1.476 2.55-1.613 4.65-3.577 2.947zM6.153 5.5c.115.578.578.79 1.11.63.595-.178 1.302.406 1.373.9.118.808.938 1.198 1.55.754-1.85 2.29-4.92.16-4.033-2.285z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "abc33e58-b555-4ce8-aa12-820c2147a922a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgHk;